import { Box, Typography, styled } from '@material-ui/core';

const accessBadge = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
  padding: '4px 12px',
  borderRadius: 6,
} as const;

export const AccessBadgeRoot = styled(Box)(({ theme }) => ({
  ...accessBadge,
  paddingLeft: 4,
  backgroundColor: theme.palette.success.main,
  color: theme.palette.common.white,
}));

export const LockedBadgeRoot = styled(Box)(({ theme }) => ({
  ...accessBadge,
  backgroundColor: 'rgba(118, 133, 150, 0.7)',
  color: theme.palette.common.white,
}));

export const AccessBadgeTitle = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontSize: 'inherit',
  fontWeight: 700,
  color: theme.palette.common.white,
}));
